import { Component, OnInit } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-frequency',
  templateUrl: './frequency.component.html',
  styleUrls: ['./frequency.component.scss']
})
export class FrequencyComponent implements OnInit {
  addOrEditFrequency: string;
  frequency = [];
  title = 'modal2';
  formGroup;
  deletePopupUiData;

  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    // public toastService: ToastService
  ) {}

  ngOnInit() {
    this.getAllFrequency();
  }

  getAllFrequency() {
    this.apiService.getHeaders(this.apiConfig.configGetFrequency)
      .subscribe((res: any) => {
        this.frequency = res.body.data
        console.log(this.frequency);
      }, err => {
        console.log(err);
      })
  }

  addFrequency(targetModal) {
    this.addOrEditFrequency = 'add'

    this.formGroup = this.fb.group({
      frequency_name: '',
      program_id: 1,
      status: 1
    });

    this.showFrequencyModal(targetModal);
  }

  editFrequency(targetModal, frequencyInfo){
    this.addOrEditFrequency = 'edit'
    this.formGroup = this.fb.group({
      id: frequencyInfo.id,
      frequency_name: frequencyInfo.frequency_name,
      status: 1
    });

    this.showFrequencyModal(targetModal);
  }

  deleteFrequency(targetModal, frequencyInfo){
    this.addOrEditFrequency = 'delete'
    this.deletePopupUiData = frequencyInfo.frequency_name;

    this.formGroup = this.fb.group({
      id: frequencyInfo.id,
      status: 0
    });

    this.showFrequencyModal(targetModal);
  }

  showFrequencyModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  

  onSubmitFrequency(formData) {
    let apiUrl;    
    if(this.addOrEditFrequency == 'add'){
      apiUrl = this.apiConfig.configAddFrequency

      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        console.log('successfully Added', res);
        this.frequencyActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })

    } else if(this.addOrEditFrequency == 'edit' || this.addOrEditFrequency == 'delete'){
      apiUrl = this.apiConfig.configEditFrequency + '?id='+ formData.id

      this.apiService.put(apiUrl, formData)
      .subscribe((res:any)=>{
        console.log('successfully Added', res);
        this.frequencyActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })

    } 

    console.log('API:', apiUrl, 'FD:', formData);

  }

  frequencyActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllFrequency();
  }
}
